<template>
    <div >
        <component :is="componentInstance" :id="String(this.id)"/>
    </div>
</template>

<script>
    import PlaceDetail from "@/views/Map/PlaceDetail.vue";
    import BuildingDetail from "@/views/Map/BuildingDetail.vue";

    export default {
        name: "MapDetail",
        components: {BuildingDetail},

        data() {
            const id = this.$route.params.id;
            const type = this.$route.params.type;
            return {
              type: type,
              id: id,
            }
        },

        mounted(){

        },
        computed: {
          componentInstance() {
              if( this.type == "place") return PlaceDetail;
              if( this.type == "building") return BuildingDetail;
              return () => import(`@/components/NotFound.vue`);
            },
        },

    }
</script>

<style scoped>

</style>
